import { Grid } from "@mui/material";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import DashboardLayout from "layouts/DashboardLayout/DashboardLayout";
import CreateOpportunity from "modules/Opportunities/CreateOpportunity/CreateOpportunity";
import DashboardNavbar from "partials/DashboardNavbar/DashboardNavbar";
import Footer from "partials/Footer/Footer";
import PageTour, { PageTourHandle } from "components/PageTour/PageTour";
import TourHelpButton from "components/PageTour/TourHelpButton";
import { useEffect, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import createOpportunityPageTourSteps from "./CreateOpportunityPage.tour";

export default function CreateOpportunityPage() {
  const tourRef = useRef<PageTourHandle>(null);
  const navigate = useNavigate();
  const location = useLocation();

  useEffect(() => {
    if ((location.state as { startTour?: boolean })?.startTour) {
      tourRef.current?.replay();
      navigate(location.pathname, { replace: true, state: {} });
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location.state]);

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <PageTour ref={tourRef} tourKey="createOpportunityPage" steps={createOpportunityPageTourSteps} />
      <MDBox my={3}>
        <MDBox mb={6}>
          <Grid container spacing={3} alignItems="center">
            <Grid item xs={12} lg={6}>
              <MDTypography variant="h4" fontWeight="medium">
                Create Opportunity
                <TourHelpButton tooltip="Click here to learn more about Creating Opportunities" onClick={() => tourRef.current?.replay()} />
              </MDTypography>
            </Grid>
          </Grid>
        </MDBox>
        <Grid container spacing={3}>
          <Grid item xs={12}>
            <CreateOpportunity />
          </Grid>
        </Grid>
      </MDBox>
      <Footer />
    </DashboardLayout>
  );
}
